import * as _ from 'underscore'

import { DataProvider } from "../helpers"
import { OpDataTypeInGroup, OpDataTypeGroup } from "../models/core"
import { Enums } from "../models/common"

export class DataProviderDataTypeGroup {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public getDataTypeInGroup = (dataTypeGroupName: string, referenceType: number = null, referenceValue: number = null): JQueryPromise<OpDataTypeInGroup[]> => {
        return this.dataProvider.System
            .getDictionaries([Enums.ReferenceType.IdDataTypeGroup, Enums.ReferenceType.IdDataTypeInGroup])
            .then(dict => {
                var result: OpDataTypeInGroup[] = []
                if (!dataTypeGroupName)
                    return result

                var dataTypeGroups: OpDataTypeGroup[] = this.dataProvider.LocalStorage.tryGetDictionaryContent<OpDataTypeGroup>(dict, Enums.ReferenceType.IdDataTypeGroup)
                var dataTypesInGroup: OpDataTypeInGroup[] = this.dataProvider.LocalStorage.tryGetDictionaryContent<OpDataTypeInGroup>(dict, Enums.ReferenceType.IdDataTypeInGroup)

                var group: OpDataTypeGroup = null


                if (referenceType == null || referenceValue == null) {
                    var groups = dataTypeGroups.filter(g => g.name == dataTypeGroupName && g.idReferenceType == null && g.referenceValue == null)
                    if (groups.length > 0) group = groups[0]
                } else {
                    var groups = dataTypeGroups.filter(g => g.name == dataTypeGroupName && g.idReferenceType == referenceType && g.referenceValue == referenceValue)
                    if (groups.length == 0) {
                        groups = dataTypeGroups.filter(g => g.name == dataTypeGroupName && g.idReferenceType == null && g.referenceValue == null)
                        if (groups.length > 0) group = groups[0]
                    } else {
                        group = groups[0]
                    }
                }

                if (group == null) return result

                const dataTypeInGroupTmp: OpDataTypeInGroup[] = _.sortBy(dataTypesInGroup.filter(d => d.idDataTypeGroup == group.idDataTypeGroup), (dataTypeInGroup: OpDataTypeInGroup) => {
                    if (dataTypeInGroup.orderNBR == null) {
                        return 0
                    } else {
                        return dataTypeInGroup.orderNBR
                    }
                })//dataTypesInGroup[group.idDataTypeGroup]//czy to wyszukiwanie naprawdę jest taki długie że tu byl potrzebny słownik?
                if (!dataTypeInGroupTmp) return result;
                else if (!group.idParentGroup)
                    return dataTypeInGroupTmp

                var dataTypeInParentGroup: OpDataTypeInGroup[] = dataTypesInGroup.filter(d => d.idDataTypeGroup == group.idParentGroup)//dataTypesInGroup[group.idDataTypeGroup]//czy to wyszukiwanie naprawdę jest taki długie że tu byl potrzebny słownik?
                if (!dataTypeInParentGroup) return dataTypeInGroupTmp

                result.push(...dataTypeInParentGroup)

                dataTypeInGroupTmp.forEach(item => {
                    var index = -1
                    result.some((d, i) => {
                        if (d.idDataType == item.idDataType) {
                            index = i
                            return true
                        }
                        return false
                    })
                    if (index > -1) {
                        result[index] = item
                    } else {
                        result.push(item)
                    }
                })

                return result
            })
    }    

    // Public Methods End
}